export const PRODUCTION = "production";
export const DEVELOPMENT = "development";
// export const API_DEV_URL = 'https://uatusermanagement.trademo.com/trademo'; // This is for UAT after UMS
export const API_DEV_URL = "https://uat.trademo.com/trademo"; // This is for Staging 1
export const API_SSO_URL = "https://uat.trademo.com/sso"; // This is for Staging 1
// export const API_DEV_URL = 'https://uat.trademo.com/trademo'; // This is for UAT
export const GLOBAL_API_DEV_URL = "https://uatusermanagement.trademo.com/trademo"; // This is for Staging after UMS
export const S_K_DEV = "pk_test_51H55FUIREutAm1mBDihQXRwiNmDMFI7DZcprWrjYL1jTGTdfoK8FOmH9nv51jRqpBt6N5eXa2Y2RwHJUZaFX2a8y00O4vhAMcw";
export const G_A_K_DEV = "359816465748-0ak4spmbs45pgj64oq0nq326bcminfsq.apps.googleusercontent.com";
export const LOCAL_WEBSITE_URL = "http://localhost:3011/";
export const LOCAL_ACCOUNTS_URL = "http://localhost:3002/";
export const LOCAL_INTEL_URL = "http://localhost:5173/";
export const LOCAL_SOURCE_ATLAS_URL = "http://localhost:5173/";
export const LOCAL_PAYMENTS_URL = "http://localhost:3004/";
export const LOCAL_COMPLIANCE_URL = "http://localhost:3012/";
export const LOCAL_SANCTIONS_URL = "http://localhost:3000/";
export const LOCAL_HS_CODE_CLASSIFICATION_URL = "http://localhost:3025";
export const LOCAL_SUPPLY_CHAIN_URL = "http://localhost:3010";
export const LOCAL_PRODUCT_MASTER_URL = "http://localhost:3017/";
export const LOCAL_TRADE_MAP_URL = "http://localhost:3000";
export const LOCAL_ESG_URL = "http://localhost:3009";
export const LOCAL_USER_MANAGEMENT_SYSTEM_URL = "http://localhost:3020";
export const SEND_BLUE_KEY_DEV = "";
export const LOCAL_VERIFY_CARD_KEY = "price_1JXJYBIREutAm1mBietknfXl";
export const LOCAL_FIN_SCREENER = "http://localhost:3005";

export const ERROR_MESSAGE = "Something went wrong!";
export const TRADEMO_LOGO = "https://res.cloudinary.com/drzta9shk/image/upload/v1765445921/website/home/Tradmo_trademarked_logo_3_plmrrs.svg";
